import { createReducer } from '@reduxjs/toolkit';
import { setNavHeaderVisibleAction, ITkbRepsonse, setTkbAction, setWidgetProgressAction, IWidgetProgressResponse } from '../actions/NavHeaderAction';

const tkbInit: ITkbRepsonse = {
	code: '',
	data: [],
	message: '',
};

const widgetProgressInit: IWidgetProgressResponse = {
	code: '',
	data: {
		qtyCurrentProcess: 0,
		qtyLoanFunded: 0,
		isShowWidgetProcess: false,
	},
	message: '',
};

const initialState = {
	navIsShown: true,
	tkb: tkbInit,
	widgetProgressAction: widgetProgressInit
};

const navHeaderReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(setNavHeaderVisibleAction, (state, action) => ({
			...state,
			navIsShown: action.payload,
		}))
		.addCase(setTkbAction, (state, action) => ({
			...state,
			tkb: action.payload,
		}))
		.addCase(setWidgetProgressAction, (state, action) => ({
			...state,
			widgetProgressAction: action.payload,
		}))
		.addDefaultCase((state) => state);
});

export default navHeaderReducer;
